import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';

function InsideHeader({ h1, h1Span, h2, background, page, description }) {
  const mediaStyle = {};
  if (background) {
    mediaStyle.backgroundImage = `url('${buildThumbnailUrl(background, { width: 2000, height: 2000 })}')`;
  }
  return (
    <div>
      <Helmet>
        <title>{`${h1} ${h1Span || ''}`} | 70 West Builders</title>
        {
          page &&
          !description &&
          <meta name="description" content={page.description} />
        }
        {
          description &&
          <meta name="description" content={description} />
        }
      </Helmet>
      <div className="inside-header" style={mediaStyle}>
        <h1>
          {h1}
          {' '}
          {
            !!h1Span &&
            <span>{h1Span}</span>
          }
        </h1>
        {
          !!h2 &&
          <div className="secondary">
            <h2>{h2}</h2>
          </div>
        }
        <div className="overlay" />
      </div>
    </div>
  );
}

InsideHeader.propTypes = {
  h1: PropTypes.string.isRequired,
  h1Span: PropTypes.string,
  h2: PropTypes.string,
  background: PropTypes.string,
  page: PropTypes.object,
  description: PropTypes.string,
};

InsideHeader.defaultProps = {
  h1Span: undefined,
  h2: undefined,
  background: undefined,
  page: undefined,
  description: undefined,
};

export default InsideHeader;



// WEBPACK FOOTER //
// ./src/components/InsideHeader/index.js